<div class="flex-login-container">
  <div class="login-panel">
    <div class="login-container">
      <div class="login-form-panel">
        @if (loading) {
          <div class="page-loading">
            <span>
              <span></span>
            </span>
          </div>
        }
        <div class="contents">
          <h2>Partner sign in</h2>

          @if (message) {
            <div style="color: green">
              {{ message }}
            </div>
          }
          <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="selector">
              <div class="row">
                <div class="small-12">
                  <label for="email"
                    >Email:
                    <input
                      type="email"
                      formControlName="email"
                      id="email"
                      autocomplete="email"
                      required
                      />
                  </label>
                </div>
              </div>
            </div>
            <div class="selector">
              <div class="row">
                <div class="small-12">
                  <label for="password"
                    >Password:
                    <input
                      type="password"
                      formControlName="password"
                      id="password"
                      autocomplete="new-password"
                      required
                      />
                  </label>
                </div>
              </div>
            </div>
            <button
              [disabled]="form.invalid"
              type="submit"
              class="btn btn-default"
              >
              SIGN IN
            </button>
            <p id="warning" class="form-error"></p>
            <p
              class="forgotten-link bottom-text"
              [routerLink]="['/forgotten-password']"
              style="cursor: pointer"
              >
              Forgotten your password?
            </p>
          </form>
        </div>
      </div>
      <div class="register-panel">
        <div class="contents">
          <h2>Welcome to PartnerChoice.co.uk</h2>
          <h4>Your Benefits. Your Rewards. Your Wellbeing.</h4>

          <div class="text-container main-text">
            <p>
              Work in the John Lewis Partnership? You’re in the right place.
            </p>
            <p>
              PartnerChoice is your exclusive platform, created to help you get
              more out of every day — because a happier business begins with
              happier Partners.
            </p>
          </div>
          <button class="button button-green" [routerLink]="['/register']">
            REGISTER
          </button>
          <div class="text-container">
            <p class="bottom-text">
              <a href="https://www.jlpjobs.com/" target="_blank"
                >Join us! Have a look at John Lewis Partnership careers here.
                <span class="fa fa-external-link"></span
                ></a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
